import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import bg from '@/assets/img/landing-info-bg.png'
import { cn } from '@bem-react/classname'

import { Button } from '@/components/UI/Button'
import Icon from '@/components/UI/Icon'

import './Info.scss'

const cnInfo = cn('Info')

interface InfoProps {
  className?: string
}

export const Info: FC<InfoProps> = ({ className }: InfoProps): JSX.Element => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className={cnInfo(null, [className])}>
      <div className={cnInfo('card')} style={{ backgroundImage: `url(${bg})` }}>
        <div className={cnInfo('title')}>
          <span>{t('landing-info-title-1-first')}</span>{' '}
          {t('landing-info-title-1-second')}
        </div>
        <div className={cnInfo('text')}>{t('landing-info-text-1')}</div>

        <Button iconPosition='right' onClick={() => navigate('/login')}>
          {t('landing-start-now')} <Icon name='chevron-right' stroke='#fff' />
        </Button>
      </div>
      <div className={cnInfo('card')} style={{ backgroundImage: `url(${bg})` }}>
        <div className={cnInfo('title')}>
          <span>{t('landing-info-title-2-first')}</span>{' '}
          {t('landing-info-title-2-second')}
        </div>
        <div className={cnInfo('text')}>{t('landing-info-text-2')}</div>
        <Button iconPosition='right' onClick={() => navigate('/login')}>
          {t('landing-start-now')}
          <Icon name='chevron-right' stroke='#fff' />
        </Button>
      </div>
    </div>
  )
}
